<atn-ds-table [config]="scenariosTableConfig" />
